import React,{useEffect, useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {DataProvider} from './store/GlobalState';
import MainPage from './components/Router'

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="w-full">
          <MainPage/>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;